import React, { useCallback, useEffect } from 'react';
import { FunctionComponent } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { authSelectors } from '../../../../../app/auth/auth.selectors';
import { initialBoardsForMeeting } from '../../../../../app/page/home/home.actions';
import { createTaskSimple } from '../../../../../app/page/page-storage/tasks-simple/tasks-simple.actions';
import { storeCurrentMeeting } from '../../../../../app/page/page-storage/meetingsOld/meetings.actions';
import { IDBTaskForm, ITaskCreate } from '../../../../../app/resource/task/task.types';
import { useRequiredValidation } from '../../../../../utils/form/validation.utils';
import { useSelect } from '../../../../../utils/selector.utils';
import { FormSmallTextInput } from '../../inputs/SmallTextInput';
import { IDBTaskFormProps } from './types';
import { SelectMeetingInput } from '../../inputs/SelectMeetingInput';
import { SelectBoardListInput } from '../../inputs/SelectBoardListInput';
import { SelectBoardInput } from '../../inputs/SelectBoardInput';

export const DBTaskForm: FunctionComponent<IDBTaskFormProps> = () => {
  const dispatch = useDispatch();
  const userId = useSelect(authSelectors.selectLoggedUser);
  const formProps = useForm();

  const { setValue } = formProps;

  const resetDependentsFieldsFor = useCallback(
    (changedField: string) => {
      if (changedField === 'meeting') {
        setValue('board', '');
        setValue('boardList', '');
      }
      if (changedField === 'board') {
        setValue('boardList', '');
      }
    },
    [setValue],
  );

  const focusMeetingTuple = formProps.watch('meeting');
  useEffect(() => {
    if (focusMeetingTuple) {
      dispatch(initialBoardsForMeeting(focusMeetingTuple.value));
    }
  }, [dispatch, focusMeetingTuple]);

  const requiredValidation = useRequiredValidation();

  const onSubmit = (data: IDBTaskForm) => {
    dispatch(storeCurrentMeeting(''));
    const newData: ITaskCreate = {
      title: data.title,
      description: '',
      dueDate: undefined,
      userId: userId ? userId : '',
      meetingIds: [data.meeting.value],
      status: '0',
      labels: [],
      members: userId ? [userId] : [],
      showInTasks: '1',
      taskTypeId: data.boardList.value,
      boardId: data.board.value,
    };
    dispatch(createTaskSimple(newData));

    formProps.reset();
  };

  useEffect(() => {
    // we clean the form to avoid setting the select options 'No Board' and 'No List'
    // in the inputs because we are creating new cards here
    setValue('board', '');
    setValue('boardList', '');
  }, [setValue]);

  return (
    <FormProvider {...formProps}>
      <form
        id="db-task-form"
        className="topic-form"
        onSubmit={formProps.handleSubmit((formData) => onSubmit(formData as IDBTaskForm))}
        method="post"
      >
        <div className="field-container">
          <FormSmallTextInput
            id="title"
            name="title"
            type="text"
            label="Card Title"
            placeholder="Enter Title"
            defaultValue=""
            validation={requiredValidation}
          />
        </div>
        <div className="field-container">
          <SelectMeetingInput onInputChange={resetDependentsFieldsFor} validation={requiredValidation} isSingle />
        </div>
        <div className="field-container">
          <SelectBoardInput
            onInputChange={resetDependentsFieldsFor}
            validation={requiredValidation}
            isSingle
            allowEmpty={true}
          />
        </div>
        <div className="field-container">
          <SelectBoardListInput onInputChange={resetDependentsFieldsFor} validation={requiredValidation} isSingle />
        </div>
      </form>
    </FormProvider>
  );
};
